export default __webpack_public_path__ + "static/media/judge-zed-logo.33dd16e1.png";